import './KnectMobileSteps.css'
import { Carousel } from 'react-responsive-carousel'
import 'react-responsive-carousel/lib/styles/carousel.min.css'
const KnectMobileSteps = () => {
	const steps = [
		{
			id: 1,
			title: 'Buy and RICA or port your number.  See how to port <a href="https://knectmobile.co.za/port" target="_blank" rel="noopener noreferrer">here</a>',
			image: 'https://cms.computicket.com/api/assets/mma/4a5a0131-c476-4ed5-9c82-d2deba2bdd61/knect-starter-pack.png?version=2',
			secondaryImage: 'https://cms.computicket.com/api/assets/mma/9b6199be-c1d3-4095-a1b8-c43055804982/steps-brand-logos.png?version='
		},
		{
			id: 2,
			title: 'Update your number on Money Market Account',
			image: 'https://cms.computicket.com/api/assets/mma/a860aee7-7fe6-4763-b878-6a30ff04c231/number-update-mockup.png?version=2',
			secondaryImage: ''
		},
		{
			id: 3,
			title: 'Recharge with R30 airtime on Money Market Account',
			image: 'https://cms.computicket.com/api/assets/mma/1b59f78e-a0a3-4886-a784-80ea9bad0bd5/recharge-mockup.png?version=2',
			secondaryImage: ''
		}
	]

	return (
		<section className="knect-mobile-steps-section">
			<div className="knect-mobile-steps-container">
				<div className="knect-mobile-steps-header">
					<div className="knect-mobile-steps-main-title">Get 5GB with k'nect mobile and Money Market Account.</div>
					<div className="knect-mobile-steps-subtitle">Your 5GB data bundle will be loaded on the 15th of the following month and will be valid for 30 days.</div>
				</div>

				<div className="knect-mobile-steps-grid">
					{steps.map((step) => (
						<div key={step.id} className="knect-mobile-step-card">
							<div className="knect-mobile-step-number">{step.id}</div>
							<div className="knect-mobile-step-title" dangerouslySetInnerHTML={{ __html: step.title }} />
							<p className="knect-mobile-step-description">{step.description}</p>
							{step.secondaryImage && (
								<div className="knect-mobile-step-secondary-image">
									<img
										src={step.secondaryImage}
										alt="Secondary Image"
										className="knect-mobile-step-secondary-img"
									/>
								</div>
							)}
							<div className="knect-mobile-step-image-wrapper">
								<img
									src={step.image}
									alt={step.title}
									className="knect-mobile-step-image"
								/>
							</div>

						</div>
					))}
				</div>
				<Carousel autoPlay infiniteLoop showStatus={false} showIndicators={false} showThumbs={false} swipeable={false}>
					<div className='knect-mobile-showcase-bottom'>
						<picture>
							<source media="(min-width: 992px)" srcSet="https://cms.computicket.com/api/assets/mma/d261c1e9-fe5a-43cc-b996-a97454e985c4/why-join-knect.png?version=1" />
							<source media="(min-width: 501px)" srcSet="https://cms.computicket.com/api/assets/mma/d261c1e9-fe5a-43cc-b996-a97454e985c4/why-join-knect.png?version=1" />
							<img src="https://cms.computicket.com/api/assets/mma/3d8b9bf5-916a-4212-beab-05016f753e1d/why-join-knect-mobile.png?version=1" alt="K'nect Mobile - Banking that buys you data" />
						</picture>
					</div>
				</Carousel>
				<div className="knect-mobile-showcase-terms-bottom">
					<p>*Offer valid for MMA customers with a linked k'nect number who meet activation requirements. 5GB paid once and loaded to the linked SIM on the 15th of the next month. Data valid 30 days. Money Market Account is a division of Shoprite Checkers (Pty) Ltd (FSP7732) with banking services sponsored by African Bank Limited (Reg. No. 2014/176899/06). Campaign ends 7 October 2026. TsCs apply.</p>
				</div>

			</div>
		</section>
	)
}

export default KnectMobileSteps
